'use strict';

function SalarySummaryController(salaryService, userService, $location, $interpolate, $q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.stepChange = stepChange;
  vm.questionIsComplete = questionIsComplete;
  vm.questionnaireIsLockable = questionnaireIsLockable;
  vm.questionnaireSetLock = questionnaireSetLock;
  vm.hasRole = _hasRole;
  vm.editComment = editComment;
  vm.createComment = createComment;
  vm.autoSaveComment = autoSaveComment;

  function $onInit() {
    vm.max = vm.data.max;
    vm.summary = vm.data.questions || [];
    vm.answers = vm.data.questions.map(function answer(question) {
      return question.answer;
    });
    vm.user = vm.data.user || {};
    vm.completed = vm.data.completed;
    vm.round = vm.data.round;
    vm.summaryComment = vm.data.comment;
    vm.isCommentEditable = false;
  }

  function questionnaireSetLock() {
    return salaryService.update.summary(vm.data.token).then(function (response) {
      vm.completed = response.data.completed;
      return response;
    });
  }

  function editComment() {
    vm.isCommentEditable = !vm.isCommentEditable;
  }

  function createComment() {
    vm.isCommentEditable = !vm.isCommentEditable;
    return salaryService.create
      .comment(vm.summaryComment, vm.data.token);
  }

  function autoSaveComment() {
    return salaryService.create
      .comment(vm.summaryComment, vm.data.token);
  }

  function questionnaireIsLockable() {
    return vm.summary.every(vm.questionIsComplete);
  }

  function questionIsComplete(question) {
    return question.answer.state === 'COMPLETE';
  }

  function stepChange(to) {
    $location.path($interpolate('/salary/questionnaire/{{token}}/{{step}}')({token: vm.data.token, step: to}));
    return $q.resolve();
  }

  function _hasRole(role) {
    return vm.me.groups.map(function (group) {
      return group.name;
    }).some(function (groupName) {
      return groupName === role;
    });
  }

}

module.exports = SalarySummaryController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-summary/salary-summary.controller.js
 ** module id = 223
 ** module chunks = 0
 **/